import { t } from "ttag";

export function getPlaceholderText() {
  return t`Write and select text to generate SQL with Metabot, or type SQL directly`;
}
